import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalPagoComponent } from './modal-pago.component';
import { MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule } from '@angular/material';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalPagoResumeComponent } from './modal-pago-resume/modal-pago-resume.component';
import { ModalPagoTotalComponent } from './modal-pago-total/modal-pago-total.component';
import { ModalPagoTotalItemComponent } from './modal-pago-total-item/modal-pago-total-item.component';
import { ModalPagoInputComponent } from './modal-pago-input/modal-pago-input.component';
import { ModalPagoVacanceComponent } from './modal-pago-vacance/modal-pago-vacance.component';

@NgModule({
  declarations: [ModalPagoComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  entryComponents: [ModalPagoComponent],
  // providers: [
  //   {
  //     provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
  //     useValue: { appearance: 'outline', subscriptSizing: 'dynamic' }
  //   }
  // ]
})
export class ModalPagoModule { }
